import { ApiContext } from '../../types'
import getCurrentBearerToken from '../authentication/getCurrentBearerToken'

import { deserializeConsignment } from '../serializers/consignment'
import { IQuery } from '@/api_client/interfaces/Query'

export default async function getConsignmentsForPayout(
  { client, config }: ApiContext,
  params: IQuery = {},
  user_id,
): Promise<any> {
  try {
    const token = await getCurrentBearerToken({
      client,
      config,
    })

    const response = await client.consignments.list(
      { bearerToken: token },
      {
        ...params,
        filter: { user_id_eq: user_id },
        per_page: 100,
        sort: '-id',
        include: '',
      },
    )
    if (response.isSuccess()) {
      const payload = response.success()
      // console.log(payload)
      const data = payload.data.map((order) =>
        deserializeConsignment(order, payload.included, config),
      )
      return data
    } else {
      throw response.fail()
    }
  } catch (e) {
    console.error(e)
    throw e
  }
}
